import { BaseAPI } from '@/lib/api';

export interface PaymentRate {
  rate: number;
  min_usd: number;
  bonus_threshold: number;
  bonus_multiplier: number;
  commission_percent: number;
}

export interface PaymentStats {
  total_payments: number;
  completed_payments: number;
  pending_payments: number;
  expired_payments: number;
  total_spent_usd: number;
  total_requests_purchased: number;
  last_successful_payment: string | null;
}

export interface PaymentItem {
  id: string;
  username: string;
  amount_usd: number;
  status: string;
  created_at: string;
  expires_at: string | null;
  created_moscow_str?: string;
  expires_moscow_str?: string;
  expected_amount_usdt: number;
  generated_address: string;
  used_requests: number | null;
  bonus_applied: boolean | null;
  transaction_hash: string | null;
}

export interface CreatePaymentRequest {
  usd_amount: number;
}

export interface CreatePaymentResponse {
  ok: boolean;
  data?: {
    payment_id: string;
  };
  error?: string;
}

export interface PaymentResponse<T = any> {
  ok: boolean;
  data?: T;
  error?: string;
}

class PaymentAPI extends BaseAPI {
  // Получение курса и настроек платежей
  async getPaymentRate(): Promise<PaymentResponse<PaymentRate>> {
    return this.makeRequest<PaymentResponse<PaymentRate>>('/api/payment/rate');
  }

  // Получение моих платежей
  async getMyPayments(): Promise<PaymentResponse<PaymentItem[]>> {
    return this.makeRequest<PaymentResponse<PaymentItem[]>>('/api/payment/my');
  }

  // Получение деталей конкретного платежа
  async getPaymentDetails(paymentId: string): Promise<PaymentResponse<PaymentItem>> {
    return this.makeRequest<PaymentResponse<PaymentItem>>(`/api/payment/${paymentId}`);
  }

  // Создание нового платежа
  async createPayment(amount: number): Promise<CreatePaymentResponse> {
    const formData = new FormData();
    formData.append('usd_amount', amount.toString());
    
    return this.makeFormRequest<CreatePaymentResponse>('/api/payment/create', formData);
  }

  // Получение статистики платежей (если нужно)
  async getPaymentStats(): Promise<PaymentResponse<PaymentStats>> {
    return this.makeRequest<PaymentResponse<PaymentStats>>('/api/payment/stats');
  }
}

export const paymentAPI = new PaymentAPI();
